import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import AdminFooter from './AdminFooter';

/**
 * AdminShell is the dedicated layout for the Super Admin platform console.
 * It replaces the generic tenant Layout for super_admin routes.
 *
 * Structure:
 * - Sidebar: fixed left, dark neutral, grouped navigation
 * - Header: sticky top, breadcrumbs, compact controls
 * - Content: scrollable main area
 * - Footer: version, health, operational links
 */
const AdminShell: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="lg:pl-64 flex flex-col min-h-screen">
        <AdminHeader onMenuClick={() => setSidebarOpen(true)} />

        <main className="flex-1 p-4 lg:p-6 overflow-x-hidden">
          <div className="max-w-[1400px] mx-auto animate-fade-in">
            <Outlet />
          </div>
        </main>

        <AdminFooter />
      </div>
    </div>
  );
};

export default AdminShell;
